define('modules/static-data-fetcher/static-data-fetcher',['require','./js/controller/static-data-fetcher-controller'],function(require) {
	"use strict";
	
	var StaticDataFetcherController = require('./js/controller/static-data-fetcher-controller'),
		controller = null;
	
	return {
		getInstance: function () {
			return {
				initialize: function (options) {
					if(null === controller) {
                		controller = new StaticDataFetcherController(options);
                	}
				},
				getStaticData: function () {
					return controller.getStaticData();
				}
			};
		}
	};
});
